import { render, staticRenderFns } from "./JobClosingComments.vue?vue&type=template&id=7086dae8&"
import script from "./JobClosingComments.vue?vue&type=script&lang=js&"
export * from "./JobClosingComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports